{
  "unsubscribe_title": "Annulla l'iscrizione alle email",
  "unsubscribe_message": "Dispiace vederti andare.",
  "unsubscribe": "Annulla iscrizione",
  "cancel": "Annulla",
  "passwordResetSuccess": "La tua password è stata cambiata con successo.",
  "passwordResetError": "Purtroppo, si è verificato un problema",
  "passwordResetExpired": "Questo link non è valido o è scaduto. Richiedi una nuova e-mail per reimpostare la password.",
  "passwordResetTooShort": "Usa almeno {min} caratteri.",
  "passwordResetTooLong": "Questa password è troppo lunga. Scegline una più corta.",
  "passwordResetTooWeak": "Questa password è troppo facile da indovinare. Scegline un'altra.",
  "passwordResetTooManyAttempts": "Troppi tentativi. Attendi qualche minuto e riprova.",
  "passwordResetTooManyAttemptsMinutes": "Troppi tentativi. Riprova tra {minutes} min.",
  "passwordResetNetworkError": "Nessuna connessione. Controlla la connessione a Internet e riprova.",
  "passwordResetTryAgain": "Non ha funzionato. Riprova tra un momento.",
  "passwordResetTitle": "Imposta una nuova password",
  "new_password": "Nuova password",
  "confirm_password": "Conferma nuova password",
  "save": "Salva",
  "error": "Purtroppo, si è verificato un problema",
  "unsubscribeSuccess": "L'azione è stata eseguita con successo",
  "emailChangeLoading": "Cambio email in corso...",
  "emailChangeSuccess": "L'email è stata modificata con successo",
  "emailChangeError": "Purtroppo, si è verificato un problema nel cambiare l'email"
}
